import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"

export default class extends Controller {
  static values = {
    mode: { type: String, default: "date" }
  }

  connect() {
    const config = this.modeValue === "time" ? this.timeConfig() : this.dateConfig()
    this.picker = flatpickr(this.element, config)
  }

  disconnect() {
    if (this.picker) {
      this.picker.destroy()
      this.picker = null
    }
  }

  dateConfig() {
    return {
      dateFormat: "d.m.Y",
      // altInput: true,
      // altFormat: "F j, Y",
      allowInput: true,
      appendTo: this.modalContainer()
    }
  }

  timeConfig() {
    return {
      enableTime: true,
      noCalendar: true,
      dateFormat: "H:i",
      // altInput: true,
      // altFormat: "h:i K",
      time_24hr: true,
      allowInput: true,
      appendTo: this.modalContainer()
    }
  }

  modalContainer() {
    return this.element.closest(".fixed") || document.body
  }
}
